import { combineReducers } from 'redux';
import register from './register';
import login from './login';
import adminLogin from './admin-login';
import forgotPassword from './forgotPassword';
import job from './job';
import jobProposal from './jobProposal';
import jobFavaourite from './jobFavourite';
import jobPost from './jobPost';
import jobs from './jobs';
import adminDashboard from './adminDashboard';
import companydetailsReducers from './companydetail';
import technology from './technology';
import coderRegisteration from './coderRegisteration';
import timezones from './timezones';
import recommendedTech from './recommendedTech';
import addressReducer from './address';
import chat from './chat/chat.reducer';

import {
  coderAddressReducer,
  coderDigitalPresence,
  coderEducationQualification,
  coderSkillsAndExperience,
  paymentOnBoard
} from './profile/coder';
import digitalPresenceReducer from './digitalPresence';
import educationForm from './educationForm';
import recommendedCoder from './recommended/coder.reducer';
import resetPassword from './resetPassword';
import resendVerifyEmailReducer from './resendVerifyEmail';
import VerifyEmailReducer from './verifyEmail';
import clientProfileReducer from './clientProfile';
import codersReducer from './coders.reducer';
import technologyReducer from './technology';
import recommendedJobs from './recommendedJobs';
import tncReducer from './tnc';
import timesheet from './timesheet';
import contract from './contract';
import userInfoReducer from './userInfo';
import adminReducer from './admin';
import chatReducer from './chat';
import SkillExperienceReducer from './skillsAndExperience';
import CoderReducer from './coder';
import latestJobs from './jobs/jobs.reducer';
import paymentReducer from './paymentReducer';
import coderFilterReducer from './coderFilter';
import jobsTabs from './jobsTabs';
import getrecommendedHomeJobsReducer from './recommended/jobs.reducer';
import contactSupport from './contact/contact.reducer';
import countryList from './countryList';
import {
  createStripAccountReducer,
  stripeFeeCalculationReducer,
  stripePaymentCheckoutReducer
} from './stripPaymentReducer';
import { createPayementInfoReducer } from './paymentInfo.reducer';

import adminDisputes from './adminReducers/adminDisputes';
import milestoneReducer from './milestoneReducer';
import notifications from './notification/notification.reducer';

import { reportDropdownReducer, reportTransactionReducer } from './report/report.reducer';

const rootReducer = combineReducers({
  register: register,
  userLoginData: login,
  adminLoginData: adminLogin,
  passwordUpdate: forgotPassword,
  resetPassword: resetPassword,
  job: job,
  jobProposal: jobProposal,
  tncReducer: tncReducer,
  jobFavaourite: jobFavaourite as any,
  jobPost: jobPost,
  jobs: jobs,
  coder: CoderReducer,
  contract: contract,
  adminDashboard,
  jobsTabs,
  companydetailsReducers: companydetailsReducers,
  profile: combineReducers({
    coderAddressReducer: coderAddressReducer,
    coderDigitalPresence,
    coderSkillsAndExperience,
    coderEducationQualification,
    paymentOnBoard
  }),
  timesheet: timesheet,
  technology: technology,
  adminReducer,
  coderRegisteration,
  timezones: timezones,
  clientProfileReducer: clientProfileReducer,
  digitalPresenceReducer: digitalPresenceReducer,
  addressReducer: addressReducer,
  recommendedTech,
  educationForm,
  recommendedCoder,
  resendVerifyEmailReducer: resendVerifyEmailReducer,
  VerifyEmailReducer,
  codersReducer,
  technologyReducer,
  recommendedJobs,
  userInfoReducer,
  coderFilterReducer,
  SkillExperienceReducer,
  latestJobs,
  paymentReducer,
  getrecommendedHomeJobsReducer,
  contactSupport,
  chatReducer,
  countryList,
  stripPamyent: combineReducers({
    createStripAccountReducer,
    stripeFeeCalculationReducer,
    stripePaymentCheckoutReducer
  }),
  paymentInfo: combineReducers({
    createPayementInfoReducer
  }),
  chat,
  adminDisputes,
  milestoneReducer,
  notifications,
  report: combineReducers({
    reportDropdownReducer,
    reportTransactionReducer
  })
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
